import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e244531"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ComplaintForm" }
const _hoisted_2 = { class: "ComplaintFormHeader" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash mr-2" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "ComplaintsLoader"
}
const _hoisted_7 = {
  key: 1,
  class: "Complaints"
}
const _hoisted_8 = { class: "ComplaintsBlock" }
const _hoisted_9 = { class: "ComplaintInputs" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Имя:", -1))
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "email:", -1))
const _hoisted_14 = { key: 2 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Номер телефона:", -1))
const _hoisted_16 = { key: 3 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Номер накладной:", -1))
const _hoisted_18 = { key: 4 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Обвиняемый сотрудник:", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Тема:", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Обращение:", -1))
const _hoisted_22 = {
  key: 0,
  class: "ComplaintsBlock"
}
const _hoisted_23 = { class: "ComplaintsBlock" }
const _hoisted_24 = { class: "ComplaintInputs" }
const _hoisted_25 = { class: "ComplaintFormFooter flex items-center justify-between mt-6" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_27 = {
  key: 2,
  class: "Complaints"
}
const _hoisted_28 = { class: "ComplaintsBlock" }
const _hoisted_29 = { class: "ComplaintInputs" }
const _hoisted_30 = { class: "flex items-center justify-end mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!
  const _component_loader = _resolveComponent("loader")!
  const _component_pretension_files = _resolveComponent("pretension-files")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_textarea = _resolveComponent("the-textarea")!
  const _component_file_reader = _resolveComponent("file-reader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_page_title, { title: _ctx.title }, null, 8, ["title"]),
        (_ctx.state.complaint && _ctx.state.complaint.status)
          ? (_openBlock(), _createBlock(_component_cheap, {
              key: 0,
              class: "small ml-6"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.state.complaint.status.name), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_button_dropdown, {
        title: "Выберите действие",
        placement: "bottom",
        "allowed-placements": ['bottom']
      }, {
        default: _withCtx(() => [
          (_ctx.complaintId)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 0,
                class: "red text small",
                loading: _ctx.state.is_loading,
                onClick: _ctx.closeComplaint
              }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _createTextVNode("Закрыть жалобу ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_the_button, {
            class: "second text small",
            disabled: _ctx.state.is_loading,
            onClick: _ctx.emitCancel
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createTextVNode(" Отмена ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _: 1
      })
    ]),
    (_ctx.state.is_loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_loader, { class: "primary" })
        ]))
      : (_ctx.state.complaint)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (_ctx.isType41)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                      _hoisted_11,
                      _createTextVNode(" " + _toDisplayString(_ctx.state.complaint.name), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isType41)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                      _hoisted_13,
                      _createTextVNode(" " + _toDisplayString(_ctx.state.complaint.email || '-'), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isType41)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                      _hoisted_15,
                      _createTextVNode(" " + _toDisplayString(_ctx.state.complaint.phoneNumber || '-'), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isType41)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                      _hoisted_17,
                      _createTextVNode(" " + _toDisplayString(_ctx.state.complaint.clientTitle || '-'), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isType42)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                      _hoisted_19,
                      _createTextVNode(" " + _toDisplayString(_ctx.state.complaint.clientTitle || '-'), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("p", null, [
                  _hoisted_20,
                  _createTextVNode(" " + _toDisplayString(_ctx.state.complaint.title || '-'), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_21,
                  _createTextVNode(" " + _toDisplayString(_ctx.state.complaint.content || '-'), 1)
                ])
              ])
            ]),
            (_ctx.state.complaint.files.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createVNode(_component_pretension_files, {
                    files: _ctx.state.complaint.files,
                    title: "Файлы"
                  }, null, 8, ["files"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_the_select, {
                  class: "mt-2",
                  placeholder: "Виновный отдел",
                  loading: _ctx.data_state.departments.is_loading,
                  failed: _ctx.data_state.departments.is_failed,
                  "error-text": "При получении списка отделов произошла ошибка",
                  "is-invalid": _ctx.payload_agree_form$.culpritSideId.$error,
                  "validation-errors": _ctx.payload_agree_form$.culpritSideId.$errors,
                  options: _ctx.data_state.departments.list,
                  value: _ctx.payload_agree.culpritSideId,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.payload_agree.culpritSideId) = $event)),
                  onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadDictionary(_ctx.data_state.departments.pagination.current_page))),
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadEmployees(1))),
                  label: "description",
                  "search-by": "description",
                  "can-deselect": ""
                }, null, 8, ["loading", "failed", "is-invalid", "validation-errors", "options", "value"]),
                _createVNode(_component_the_select, {
                  class: "mt-2",
                  placeholder: "Виновный сотрудник",
                  loading: _ctx.data_state.employees.is_loading,
                  failed: _ctx.data_state.employees.is_failed,
                  "error-text": "При получении списка сотрудников произошла ошибка",
                  options: _ctx.data_state.employees.list,
                  value: _ctx.payload_agree.culpritEmployeeId,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.payload_agree.culpritEmployeeId) = $event)),
                  "is-invalid": _ctx.payload_agree_form$.culpritEmployeeId.$error,
                  "validation-errors": _ctx.payload_agree_form$.culpritEmployeeId.$errors,
                  onRefresh: _ctx.loadEmployees,
                  onLoadmore: _cache[4] || (_cache[4] = ($event: any) => (
                            _ctx.loadMoreEmployees(_ctx.data_state.employees.pagination.current_page + 1)
                        )),
                  onSearch: _ctx.searchEmployees,
                  onOptionBySearch: _ctx.unshiftFindedEmployee,
                  label: "fullName",
                  "search-by": "fullName",
                  "infinite-scroll": "",
                  "can-deselect": ""
                }, null, 8, ["loading", "failed", "options", "value", "is-invalid", "validation-errors", "onRefresh", "onSearch", "onOptionBySearch"]),
                _createVNode(_component_the_input, {
                  type: "date",
                  placeholder: "Дата согласования",
                  value: _ctx.payload_agree.agreementDate,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.payload_agree.agreementDate) = $event)),
                  "is-invalid": _ctx.payload_agree_form$.agreementDate.$error,
                  "validation-errors": _ctx.payload_agree_form$.agreementDate.$errors
                }, null, 8, ["value", "is-invalid", "validation-errors"]),
                _createVNode(_component_the_select, {
                  "can-deselect": "",
                  class: "w-full mt-2",
                  placeholder: "Тип",
                  options: _ctx.COMPLAINT_TYPE_OPTIONS,
                  value: _ctx.payload_agree.categoryId,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.payload_agree.categoryId) = $event)),
                  "is-invalid": _ctx.payload_agree_form$.categoryId.$error,
                  "validation-errors": _ctx.payload_agree_form$.categoryId.$errors
                }, null, 8, ["options", "value", "is-invalid", "validation-errors"])
              ]),
              _createVNode(_component_the_textarea, {
                class: "mt-3",
                placeholder: "Согласование",
                "is-invalid": _ctx.payload_agree_form$.agreement.$error,
                "validation-errors": _ctx.payload_agree_form$.agreement.$errors,
                value: _ctx.payload_agree.agreement,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.payload_agree.agreement) = $event)),
                rows: 5,
                autoheight: ""
              }, null, 8, ["is-invalid", "validation-errors", "value"]),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_the_button, {
                  class: "second text small",
                  disabled: _ctx.state.is_loading,
                  onClick: _ctx.resetAgreeForm
                }, {
                  default: _withCtx(() => [
                    _hoisted_26,
                    _createTextVNode(" Сбросить ")
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]),
                _createVNode(_component_the_button, {
                  class: "primary text small",
                  loading: _ctx.state.is_loading,
                  onClick: _ctx.agreeComplaint
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Добавить ")
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_the_select, {
                  class: "w-full mt-2",
                  placeholder: "Тип жалобы",
                  options: _ctx.COMPLAINT_TYPES,
                  value: _ctx.payload_add.typeId,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.payload_add.typeId) = $event)),
                  disabled: ""
                }, null, 8, ["options", "value"]),
                _createVNode(_component_the_select, {
                  class: "mt-2",
                  placeholder: "Виновный сотрудник",
                  loading: _ctx.data_state.employees.is_loading,
                  failed: _ctx.data_state.employees.is_failed,
                  "error-text": "При получении списка сотрудников произошла ошибка",
                  options: _ctx.data_state.employees.list,
                  value: _ctx.payload_add.clientId,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.payload_add.clientId) = $event)),
                  "is-invalid": _ctx.payload_add_form$.clientId.$error,
                  "validation-errors": _ctx.payload_add_form$.clientId.$errors,
                  onRefresh: _ctx.loadEmployees,
                  onLoadmore: _cache[10] || (_cache[10] = ($event: any) => (
                            _ctx.loadMoreEmployees(_ctx.data_state.employees.pagination.current_page + 1)
                        )),
                  onSearch: _ctx.searchEmployees,
                  onOptionBySearch: _ctx.unshiftFindedEmployee,
                  label: "fullName",
                  "search-by": "fullName",
                  "infinite-scroll": ""
                }, null, 8, ["loading", "failed", "options", "value", "is-invalid", "validation-errors", "onRefresh", "onSearch", "onOptionBySearch"]),
                _createVNode(_component_the_input, {
                  placeholder: "Тема",
                  value: _ctx.payload_add.title,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.payload_add.title) = $event)),
                  "is-invalid": _ctx.payload_add_form$.title.$error,
                  "validation-errors": _ctx.payload_add_form$.title.$errors
                }, null, 8, ["value", "is-invalid", "validation-errors"]),
                _createVNode(_component_the_select, {
                  "can-deselect": "",
                  class: "w-full mt-2",
                  placeholder: "Тип",
                  options: _ctx.COMPLAINT_TYPE_OPTIONS,
                  value: _ctx.payload_add.categoryId,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.payload_add.categoryId) = $event)),
                  "is-invalid": _ctx.payload_add_form$.categoryId.$error,
                  "validation-errors": _ctx.payload_add_form$.categoryId.$errors
                }, null, 8, ["options", "value", "is-invalid", "validation-errors"])
              ]),
              _createVNode(_component_the_textarea, {
                class: "mt-3",
                placeholder: "Обращение",
                "is-invalid": _ctx.payload_add_form$.content.$error,
                "validation-errors": _ctx.payload_add_form$.content.$errors,
                value: _ctx.payload_add.content,
                "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.payload_add.content) = $event)),
                rows: 5,
                autoheight: ""
              }, null, 8, ["is-invalid", "validation-errors", "value"]),
              _createVNode(_component_file_reader, {
                class: "mt-3",
                placeholder: "Выберите файл",
                accept: "image/*, application/pdf",
                value: _ctx.payload_add.files,
                "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.payload_add.files) = $event)),
                multiple: ""
              }, null, 8, ["value"]),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_the_button, {
                  class: "primary text small",
                  loading: _ctx.state.is_loading,
                  onClick: _ctx.addComplaint
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Создать ")
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"])
              ])
            ])
          ]))
  ]))
}